import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const UpgradePopup = loadAsyncComponent(() => import('./View'), 'popup');
